import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { CheckCircle2, Sparkles, ChevronDown } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-end overflow-hidden" data-id="element-131">
      {/* ── FULL-BLEED BACKGROUND IMAGE ── */}
      <div className="absolute inset-0 z-0" data-id="element-132">
        <img src="https://cdn.magicpatterns.com/uploads/6uWfPuDJ4S74kELu7eQGqo/daniel_sanchez_portada_el_poder_de_tu_Marca.jpg" alt="" className="w-full h-full object-cover object-center" data-id="element-133" />
        {/* Dark vignette — heavier at bottom so text is readable */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#050510] via-[#050510]/70 to-[#050510]/30" data-id="element-134" />
        {/* Left-side darkening for text legibility */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#050510]/80 via-[#050510]/30 to-transparent" data-id="element-135" />
        {/* Subtle noise texture */}
        <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20" data-id="element-136" />
        {/* Cyan glow accent */}
        <div className="absolute bottom-0 left-0 w-[600px] h-[400px] bg-cyan-500/10 rounded-full blur-[150px]" data-id="element-137" />
        <div className="absolute top-20 right-20 w-[400px] h-[400px] bg-purple-600/10 rounded-full blur-[120px]" data-id="element-138" />
      </div>

      {/* ── CONTENT — sits over the image ── */}
      <div className="relative z-10 w-full pb-20 pt-32 px-4" data-id="element-139">
        <div className="container mx-auto max-w-5xl" data-id="element-140">
          {/* Badge */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/15 mb-6 backdrop-blur-md" data-id="element-141">
            <Sparkles className="w-4 h-4 text-cyan-400" data-id="element-142" />
            <span className="text-sm font-semibold text-cyan-100 tracking-wide" data-id="element-143">
              Programa de 15 días
            </span>
          </motion.div>

          {/* Main headline */}
          <motion.h1 initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.9,
          delay: 0.15
        }} className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-extrabold leading-[1.0] tracking-tight mb-6 drop-shadow-2xl" data-id="element-144">
            EL ARTE DE
            <br data-id="element-145" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-purple-400 to-pink-400" data-id="element-146">
              MONETIZAR
            </span>
            <br data-id="element-147" />
            <span className="text-white/90" data-id="element-148">TUS REDES</span>
          </motion.h1>

          {/* Subheadline */}
          <motion.p initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.35
        }} className="text-lg md:text-xl text-gray-200 mb-8 max-w-2xl leading-relaxed drop-shadow-lg" data-id="element-149">
            Crea y vende tu primer producto digital rentable en solo 15 días —
            aunque hoy no sepas qué vender, no tengas producto y no seas
            influencer.
          </motion.p>

          {/* Pills */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.5
        }} className="flex flex-wrap gap-3 mb-10" data-id="element-150">
            {['Sin miles de seguidores', 'Sin experiencia técnica', 'Sin productos previos'].map((item, i) => <div key={i} className="flex items-center gap-2 text-gray-200 bg-black/40 backdrop-blur-md px-4 py-2 rounded-lg border border-white/10" data-id="element-151">
                <CheckCircle2 className="w-4 h-4 text-green-400 flex-shrink-0" data-id="element-152" />
                <span className="text-sm font-medium" data-id="element-153">{item}</span>
              </div>)}
          </motion.div>

          {/* Price + CTA block */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.7
        }} className="flex flex-col sm:flex-row items-start sm:items-center gap-6 flex-wrap" data-id="element-154">
            {/* Price */}
            <div className="flex items-center gap-3 bg-black/50 backdrop-blur-md px-5 py-3 rounded-2xl border border-white/10" data-id="element-155">
              <span className="text-gray-400 line-through text-lg" data-id="element-156">$97.00</span>
              <span className="text-4xl font-black text-white tracking-tight" data-id="element-157">
                $16.39
              </span>
              <span className="bg-green-500/25 text-green-400 px-3 py-1 rounded-full text-sm font-bold border border-green-500/30" data-id="element-158">
                -83% OFF
              </span>
            </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto" data-id="element-159">
              <CTAButton size="lg" className="min-w-[280px]" data-id="element-160" />
              <motion.a href="#programa" whileHover={{
              scale: 1.03
            }} whileTap={{
              scale: 0.97
            }} className="inline-flex items-center justify-center gap-2 px-6 py-4 rounded-full font-bold text-white border border-white/20 bg-white/5 backdrop-blur-md hover:bg-white/10 transition-all duration-300 text-base" data-id="element-161">
                Ver más información
                <ChevronDown className="w-4 h-4" data-id="element-162" />
              </motion.a>
            </div>
          </motion.div>

          {/* Trust line */}
          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 1
        }} className="text-sm text-gray-400 mt-5" data-id="element-163">
            🔒 Acceso inmediato &nbsp;•&nbsp; ⚡ Garantía de 7 días
            &nbsp;•&nbsp; 🌎 Funciona en cualquier país
          </motion.p>
        </div>
      </div>

      {/* Scroll indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 0.8
    }} className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-1 text-gray-500" data-id="element-164">
        <span className="text-xs tracking-widest uppercase" data-id="element-165">Scroll</span>
        <motion.div animate={{
        y: [0, 6, 0]
      }} transition={{
        repeat: Infinity,
        duration: 1.5,
        ease: 'easeInOut'
      }} data-id="element-166">
          <ChevronDown className="w-5 h-5" data-id="element-167" />
        </motion.div>
      </motion.div>
    </section>;
}